import darkThemeIcon from "../assets/generated/icon-theme-dark-v1.png";
import lightThemeIcon from "../assets/generated/icon-theme-light-v1.png";

export function ThemeToggle({ dark, onToggle }: { dark: boolean; onToggle: () => void }) {
  return (
    <button
      aria-checked={dark}
      aria-label={dark ? "Use light theme" : "Use dark theme"}
      className="theme-toggle"
      onClick={onToggle}
      role="switch"
      type="button"
    >
      <span className="theme-toggle-thumb" />
      <img
        alt=""
        className={`theme-toggle-icon theme-toggle-light${dark ? "" : " is-active"}`}
        src={lightThemeIcon}
      />
      <img
        alt=""
        className={`theme-toggle-icon theme-toggle-dark${dark ? " is-active" : ""}`}
        src={darkThemeIcon}
      />
    </button>
  );
}
